export const SMART_SEGMENTS_DELETE_SEGMENT_RESPONSE = 'SMARTSEGMENTS_DELETESEGMENT_RESPONSE'
export const SMART_SEGMENTS_RENAME_SEGMENT_RESPONSE = 'SMARTSEGMENTS_CURRENT_RENAME_RESPONSE'
export const SMARTSEGMENTS_CURRENT_UPDATEFILTER_RESPONSE =
  'SMARTSEGMENTS_CURRENT_UPDATEFILTER_RESPONSE'
export const SMART_SEGMENTS_GET_USES_LIST = 'SMART_SEGMENTS_GET_USES_LIST'
